/**
 * Template para email de confirmación al usuario
 * Enviado solo al usuario como agradecimiento
 */
export const confirmationEmailTemplate = (data) => ({
  html: `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Confirmación de mensaje - Amalgamatech</title>
      <style>
        * { box-sizing: border-box; }
        body { 
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
          margin: 0; 
          padding: 0; 
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          min-height: 100vh;
          line-height: 1.6;
        }
        .email-wrapper {
          padding: 32px 16px;
          min-height: 100vh;
        }
        .container { 
          max-width: 600px; 
          margin: 0 auto; 
          background: #ffffff;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
        }
        .header { 
          background: linear-gradient(135deg, #0ea5e9 0%, #3b82f6 50%, #8b5cf6 100%);
          padding: 48px 32px;
          text-align: center;
          position: relative;
        }
        .header::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="50" r="1" fill="%23ffffff" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>') repeat;
        }
        .header-content {
          position: relative;
          z-index: 1;
        }
        .logo {
          width: 64px;
          height: 64px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          margin: 0 auto 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 32px;
          backdrop-filter: blur(10px);
        }
        .header h1 { 
          color: #ffffff;
          margin: 0 0 8px 0;
          font-size: 32px;
          font-weight: 800;
          letter-spacing: -0.025em;
        }
        .header p {
          color: rgba(255, 255, 255, 0.9);
          margin: 0;
          font-size: 18px;
          font-weight: 500;
        }
        .content { 
          padding: 48px 32px;
          background: #ffffff;
        }
        .greeting {
          font-size: 20px;
          font-weight: 600;
          color: #1f2937;
          margin: 0 0 24px 0;
        }
        .message-card {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          border-radius: 12px;
          padding: 24px;
          margin: 24px 0;
          border-left: 4px solid #3b82f6;
        }
        .message-card h3 {
          color: #1e293b;
          margin: 0 0 12px 0;
          font-size: 16px;
          font-weight: 600;
        }
        .message-card p {
          color: #475569;
          margin: 0;
          font-size: 15px;
        }
        .content p {
          color: #374151;
          margin: 0 0 16px 0;
          font-size: 16px;
          line-height: 1.7;
        }
        .highlight {
          background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
          color: #1e40af;
          padding: 2px 8px;
          border-radius: 6px;
          font-weight: 600;
        }
        .cta-section {
          text-align: center;
          margin: 32px 0;
          padding: 24px;
          background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
          border-radius: 12px;
        }
        .cta-text {
          color: #92400e;
          font-size: 15px;
          margin: 0;
          font-weight: 500;
        }
        .footer { 
          background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
          color: #9ca3af;
          padding: 32px;
          text-align: center;
        }
        .footer-brand {
          color: #ffffff;
          font-size: 18px;
          font-weight: 700;
          margin: 0 0 8px 0;
        }
        .footer-tagline {
          color: #6b7280;
          font-size: 14px;
          margin: 0 0 16px 0;
        }
        .footer-links {
          display: flex;
          justify-content: center;
          gap: 24px;
          margin: 16px 0 0 0;
        }
        .footer-link {
          color: #9ca3af;
          text-decoration: none;
          font-size: 14px;
          transition: color 0.3s ease;
        }
        .footer-link:hover {
          color: #ffffff;
        }
        @media (max-width: 640px) { 
          .email-wrapper { padding: 16px 8px; }
          .container { border-radius: 12px; }
          .header { padding: 32px 24px; }
          .header h1 { font-size: 28px; }
          .content { padding: 32px 24px; }
          .footer { padding: 24px; }
          .footer-links { flex-direction: column; gap: 12px; }
        }
      </style>
    </head>
    <body>
      <div class="email-wrapper">
        <div class="container">
          <div class="header">
            <div class="header-content">
              <div class="logo">🚀</div>
              <h1>¡Mensaje Recibido!</h1>
              <p>Te responderemos muy pronto</p>
            </div>
          </div>
          
          <div class="content">
            <p class="greeting">Hola ${data.nombre},</p>
            
            <p>Gracias por contactar con <strong>Amalgamatech</strong>. Hemos recibido tu mensaje y queremos confirmarte que llegó correctamente a nuestro equipo.</p>
            
            <div class="message-card">
              <h3>📋 Resumen de tu consulta:</h3>
              <p><strong>Asunto:</strong> <span class="highlight">${data.motivo}</span></p>
              <p><strong>Nombre:</strong> ${data.nombre}</p>
              <p><strong>Email de contacto:</strong> ${data.email}</p>
              <p><strong>Mensaje:</strong> ${data.mensaje}</p>
            </div>
            
            <p>Nuestro equipo revisará tu mensaje y te responderemos en un plazo máximo de <strong>24-48 horas</strong> en la dirección de email que nos proporcionaste.</p>
            
            <div class="cta-section">
              <p class="cta-text">💡 Mientras tanto, puedes explorar nuestros servicios y proyectos en nuestra web</p>
            </div>
            
            <p>Si tienes alguna pregunta urgente, no dudes en contactarnos directamente.</p>
            
            <p style="margin-top: 32px; color: #6b7280; font-style: italic;">Gracias por confiar en Amalgamatech para tu proyecto.</p>
          </div>
          
          <div class="footer">
            <p class="footer-brand">Amalgamatech</p>
            <p class="footer-tagline">Desarrollo de Software Ágil & Soluciones Tecnológicas</p>
          </div>
        </div>
      </div>
    </body>
    </html>
  `,
  
  text: `Hola ${data.nombre},\n\nHemos recibido tu mensaje sobre: ${data.motivo}\n\nTe responderemos lo antes posible.\n\nGracias,\nAmalgamatech`,
  
  subject: `Amalgamatech - Confirmación: ${data.motivo}`
});